"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var jdStoreApi = _interopRequireWildcard(require("@/api/jdStoreApi"));
var _JdSkuDetail = _interopRequireDefault(require("./components/JdSkuDetail.vue"));
var _JdGoodsPriceAdjustDialog = _interopRequireDefault(require("./components/JdGoodsPriceAdjustDialog.vue"));
var _JdGoodsPriceRecordDialog = _interopRequireDefault(require("./components/JdGoodsPriceRecordDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JdSkuList',
  components: {
    JdSkuDetail: _JdSkuDetail.default,
    JdGoodsPriceAdjustDialog: _JdGoodsPriceAdjustDialog.default,
    JdGoodsPriceRecordDialog: _JdGoodsPriceRecordDialog.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.pageLyp.limit[0],
        cate1: '',
        cate2: '',
        cate3: '',
        brandName: '',
        skuid: '',
        productName: '',
        sortType: '',
        status: '',
        deliveryType: ''
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      exportLoading: false,
      cate1Options: [],
      clearCacheLoading: false,
      cate2Options: [],
      cate3Options: [],
      cate1Loading: false,
      cate2Loading: false,
      cate3Loading: false,
      sortOptions: [],
      sortLoading: false
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
    this.fetchCate1Options('');
    this.fetchSortOptions();
  },
  methods: {
    formatCategory: function formatCategory(row) {
      if (!row) return '--';
      var a = row.categoryOneName || '';
      var b = row.categoryTwoName || '';
      var c = row.categoryThreeName || '';
      var text = [a, b, c].filter(function (s) {
        return s;
      }).join('/');
      return text || '--';
    },
    getPriceDiff: function getPriceDiff(row) {
      if (row.salePrice == null || row.retail == null) return 0;
      var diff = parseFloat(row.salePrice) - parseFloat(row.retail);
      if (Math.abs(diff) < 0.001) return 0;
      return diff;
    },
    getPriceClass: function getPriceClass(row) {
      var diff = this.getPriceDiff(row);
      if (diff > 0) return 'price-up';
      if (diff < 0) return 'price-down';
      return '';
    },
    getAdjustRatio: function getAdjustRatio(row) {
      if (row.salePrice == null || row.retail == null) return '--';
      var diff = parseFloat(row.salePrice) - parseFloat(row.retail);
      if (Math.abs(diff) < 0.001) return '--';
      var ratio = (diff / parseFloat(row.retail) * 100).toFixed(2);
      return ratio;
    },
    formatListStatus: function formatListStatus(v) {
      if (String(v) === '1') return '上架';
      if (String(v) === '0') return '下架';
      return '--';
    },
    formatYn: function formatYn(v) {
      if (String(v) === '1') return '有效';
      if (String(v) === '2') return '无效';
      return '--';
    },
    formatManualAdjust: function formatManualAdjust(v) {
      if (String(v) === '1') return '是';
      if (String(v) === '0') return '否';
      return '--';
    },
    formatSelfSellType: function formatSelfSellType(v) {
      if (String(v) === '1') return '京东自营';
      if (String(v) === '0') return '非自营';
      return '--';
    },
    formatLogisticsType: function formatLogisticsType(v) {
      if (String(v) === '0') return '第三方配送';
      if (String(v) === '1') return '京东配送';
      if (String(v) === '2') return '未知类型';
      return '--';
    },
    fetchSortOptions: function fetchSortOptions() {
      var _this = this;
      if (this.sortLoading) return Promise.resolve();
      this.sortLoading = true;
      return jdStoreApi.getJdMallSortOptions().then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var data = res.data || res;
        var list = Array.isArray(data) ? data : Array.isArray(data.data) ? data.data : [];
        _this.sortOptions = (Array.isArray(list) ? list : []).map(function (it) {
          return {
            value: String(it.id),
            label: String(it.name)
          };
        });
      }).catch(function () {
        _this.sortOptions = [];
      }).finally(function () {
        _this.sortLoading = false;
      });
    },
    getGoodsListRequestBody: function getGoodsListRequestBody() {
      var p = this.listPram || {};
      var logisticsTypeMap = {
        third: 0,
        jd: 1,
        unknown: 2
      };
      var logisticsType = p.deliveryType === '' || p.deliveryType === undefined || p.deliveryType === null ? undefined : logisticsTypeMap[p.deliveryType] !== undefined ? logisticsTypeMap[p.deliveryType] : p.deliveryType;
      return {
        page: p.page,
        limit: p.limit,
        brandName: p.brandName || undefined,
        categoryOne: p.cate1 || undefined,
        categoryTwo: p.cate2 || undefined,
        categoryThree: p.cate3 || undefined,
        skuId: p.skuid || undefined,
        skuName: p.productName || undefined,
        sort: p.sortType || undefined,
        listStatus: p.status === '' ? undefined : p.status,
        logisticsType: logisticsType
      };
    },
    fetchCate1Options: function fetchCate1Options(keyword) {
      var _this2 = this;
      this.cate1Loading = true;
      return jdStoreApi.getJdCategoryOneList({
        keyword: keyword || ''
      }).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var list = Array.isArray(res) ? res : Array.isArray(res.data) ? res.data : [];
        _this2.cate1Options = list;
      }).catch(function () {
        _this2.cate1Options = [];
      }).finally(function () {
        _this2.cate1Loading = false;
      });
    },
    fetchCate2Options: function fetchCate2Options(keyword) {
      var _this3 = this;
      if (!this.listPram.cate1) {
        this.cate2Options = [];
        return Promise.resolve();
      }
      this.cate2Loading = true;
      return jdStoreApi.getJdCategoryTwoList({
        keyword: keyword || '',
        categoryOneId: this.listPram.cate1
      }).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var list = Array.isArray(res) ? res : Array.isArray(res.data) ? res.data : [];
        _this3.cate2Options = list;
      }).catch(function () {
        _this3.cate2Options = [];
      }).finally(function () {
        _this3.cate2Loading = false;
      });
    },
    fetchCate3Options: function fetchCate3Options(keyword) {
      var _this4 = this;
      if (!this.listPram.cate2) {
        this.cate3Options = [];
        return Promise.resolve();
      }
      this.cate3Loading = true;
      return jdStoreApi.getJdCategoryThreeList({
        keyword: keyword || '',
        categoryTwoId: this.listPram.cate2
      }).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var list = Array.isArray(res) ? res : Array.isArray(res.data) ? res.data : [];
        _this4.cate3Options = list;
      }).catch(function () {
        _this4.cate3Options = [];
      }).finally(function () {
        _this4.cate3Loading = false;
      });
    },
    onSortVisibleChange: function onSortVisibleChange(visible) {
      if (visible) this.fetchSortOptions();
    },
    onCate1Change: function onCate1Change() {
      this.listPram.cate2 = '';
      this.listPram.cate3 = '';
      this.cate2Options = [];
      this.cate3Options = [];
      if (this.listPram.cate1) this.fetchCate2Options('');
    },
    onCate2Change: function onCate2Change() {
      this.listPram.cate3 = '';
      this.cate3Options = [];
      if (this.listPram.cate2) this.fetchCate3Options('');
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleReset: function handleReset() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        cate1: '',
        cate2: '',
        cate3: '',
        brandName: '',
        skuid: '',
        productName: '',
        sortType: '',
        status: '',
        deliveryType: ''
      };
      this.cate2Options = [];
      this.cate3Options = [];
      this.handlerGetListData();
    },
    handleClearCache: function handleClearCache() {
      var _this5 = this;
      if (this.clearCacheLoading) return;
      this.clearCacheLoading = true;
      jdStoreApi.clearJdMallCache().then(function () {
        _this5.$message.success('缓存已清除');
      }).catch(function () {
        _this5.$message.error('清除缓存失败');
      }).finally(function () {
        _this5.clearCacheLoading = false;
      });
    },
    handlerGetListData: function handlerGetListData() {
      var _this6 = this;
      this.listLoading = true;
      var body = this.getGoodsListRequestBody();
      jdStoreApi.getJdSkuList(body).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var data = res.data || res;
        var list = Array.isArray(data.list) ? data.list : [];
        var total = data.total || 0;
        _this6.listData = {
          list: list,
          total: total
        };
      }).catch(function () {
        _this6.listData = {
          list: [],
          total: 0
        };
      }).finally(function () {
        _this6.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    handleExport: function handleExport() {
      var _this7 = this;
      this.exportLoading = true;
      jdStoreApi.exportJdSkuList(this.listPram).then(function () {
        _this7.$message.success('导出任务已提交');
      }).catch(function () {
        _this7.$message.error('导出失败');
      }).finally(function () {
        _this7.exportLoading = false;
      });
    },
    handleImport: function handleImport() {
      this.$message.info('导入商品列表功能待对接');
    },
    handleListStatusChange: function handleListStatusChange(row, val) {
      var _this8 = this;
      var skuId = row && row.skuId;
      var newStatus = val;
      var oldStatus = newStatus === 1 ? 0 : 1;
      if (skuId === undefined || skuId === null || skuId === '') {
        this.$message.error('缺少skuId');
        this.$set(row, 'listStatus', oldStatus);
        return;
      }
      jdStoreApi.updateJdGoodsStatus({
        skuId: skuId,
        listStatus: newStatus
      }).then(function (res) {
        if (res == '操作成功') {
          _this8.$message.success('操作成功');
          _this8.handlerGetListData();
          return;
        }
        _this8.handlerGetListData();
        _this8.$set(row, 'listStatus', oldStatus);
        _this8.$message.error(res && res.message || '操作失败');
      }).catch(function () {
        _this8.handlerGetListData();
        _this8.$set(row, 'listStatus', oldStatus);
        _this8.$message.error('操作失败');
      });
    },
    openDetail: function openDetail(row) {
      this.$refs.jdSkuDetailRef && this.$refs.jdSkuDetailRef.open(row);
    },
    openPriceAdjust: function openPriceAdjust(row) {
      this.$refs.jdGoodsPriceAdjustRef && this.$refs.jdGoodsPriceAdjustRef.open(row);
    },
    openPriceRecord: function openPriceRecord(row) {
      this.$refs.jdGoodsPriceRecordRef && this.$refs.jdGoodsPriceRecordRef.open(row);
    }
  }
};